import React from "react";
import loading from '../assets/loading.gif'

export default function Loading() {
  return (
    <div style={{width: '100vw', height: '100%', backgroundColor: '#000', zIndex: 10000, display: 'flex', justifyContent: 'center'}}>
      <img style={{width: '90px', height: '90px'}} src={loading} />
    </div>
  )
}